import { setupAppSignal } from '../javascript/lib/appsignal';
import { metaContent } from '../javascript/lib/dom/meta';
setupAppSignal({
  key: metaContent('appsignal:key'),
  revision: metaContent('appsignal:revision'),
});
import { sendError } from '../javascript/lib/appsignal/send_error';
window.sendError = sendError;

import '@hotwired/turbo-rails';

// Only import what we need from bootstrap
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/tab';

import '@oddcamp/cocoon-vanilla-js';
import 'focus-visible';
import 'sortable-tablesort/src/sortable';
import 'sortable-tablesort/src/sortable.a11y';

import '../javascript/lib/bridge';

import application from '../controllers';
import { installErrorHandler } from '@appsignal/stimulus';
if (window.appsignal) {
  installErrorHandler(window.appsignal, application);
}

application.start();

import { controllers } from '@joemasilotti/bridge-components';
// `bridge--menu` is overridden locally in controllers/bridge/menu_controller.js.
application.load(
  controllers.filter(({ identifier }) => identifier !== 'bridge--menu')
);

// Needs to be in `vendor` so there's only one import of Bootstrap's `Modal`
import '../javascript/lib/bootstrap_turbo';
